<template>
	<div class="od-detail">
		<div class="od-head">
			<v-icon small color="primary" class="mr-1">mdi-sale</v-icon>
			<span class="od-head-title">{{ item.name || 'Offerta' }}</span>
			<span class="od-muted">· {{ sconto(item) }}</span>
			<v-spacer></v-spacer>
			<v-btn x-small outlined color="primary" @click="$emit('edit')"><v-icon left x-small>mdi-pencil-outline</v-icon>Modifica</v-btn>
			<v-btn x-small text color="error" @click="$emit('delete')"><v-icon left x-small>mdi-delete-outline</v-icon>Elimina</v-btn>
		</div>

		<div class="od-body">
			<div>
				<div class="od-section">Come funziona</div>
				<div class="od-box od-pad">
					<div class="od-sentence">{{ frase(item) }}</div>
					<div v-if="avvisoDate" class="od-warn mt-2">
						<v-icon x-small color="warning" class="mr-1">mdi-alert-outline</v-icon>Offerta {{ statoDate(item).testo }}: anche con l'interruttore acceso il sito non la applica
						{{ statoDate(item).testo === 'scaduta' ? 'più' : 'finché non inizia' }}.
					</div>
					<div v-if="item.operation === 'bundle'" class="mt-3 od-small">
						<div class="d-flex justify-space-between">
							<span>Bundle venduti</span><strong>{{ statistiche ? statistiche.bundles : item.progress || 0 }}</strong>
						</div>
						<div v-if="statistiche" class="d-flex justify-space-between mt-1">
							<span>Sconto concesso</span><strong>{{ euro(statistiche.totalDiscount) }}</strong>
						</div>
						<div v-if="item.slug" class="mt-1 od-muted">Pagina: /offers/bundle/{{ item.slug }}</div>
					</div>
					<div v-if="item.operation === 'quantity'" class="mt-3">
						<div class="d-flex justify-space-between od-small">
							<span>Quantità usate</span><strong>{{ item.progress || 0 }} su {{ item.quantity || 0 }}</strong>
						</div>
						<v-progress-linear :value="percentuale" height="6" rounded :color="percentuale >= 100 ? 'error' : 'primary'" class="mt-1"></v-progress-linear>
					</div>
				</div>

				<div class="od-section mt-4">Esempio di prezzo</div>
				<div v-if="item.operation === 'bundle'" class="od-box od-pad od-small">
					<div v-for="(riga, i) in esempioBundle" :key="i" class="d-flex justify-space-between">
						<span class="od-muted">{{ i + 1 }}° prodotto</span>
						<span><s v-if="riga.sconto" class="od-old mr-1">{{ euro(riga.prima) }}</s><strong>{{ euro(riga.dopo) }}</strong></span>
					</div>
				</div>
				<div v-else class="od-box od-pad od-price">
					<span class="od-muted">Un prodotto da</span>
					<s class="od-old">{{ euro(100) }}</s>
					<v-icon small>mdi-arrow-right</v-icon>
					<strong class="od-new">{{ euro(prezzoScontato(item, 100)) }}</strong>
				</div>
			</div>

			<div>
				<div class="od-section">Si applica a</div>
				<div class="od-box od-pad od-small">
					<div v-if="!referenze.length" class="od-muted">Tutto il catalogo, per tutti i clienti</div>
					<div v-for="(r, i) in referenze" :key="i" class="od-ref">
						<v-icon x-small class="mr-1">{{ r.icona }}</v-icon
						>{{ r.testo }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { sconto, euro, prezzoScontato, prezziBundle, statoDate, frase, formatItemText, nomeCliente } from './formato';

// dettaglio di un'offerta nella lista: la regola in parole, un esempio di prezzo e a cosa si applica
export default {
	name: 'OfferDetail',
	props: {
		item: { type: Object, required: true },
	},
	data() {
		// bundle: ordini e sconto concesso, letti dagli ordini all'apertura del dettaglio
		return { statistiche: null };
	},
	mounted() {
		if (this.item.operation === 'bundle') this.caricaStatistiche();
	},
	computed: {
		...mapGetters({ getUrl: 'settings/getUrl', getToken: 'profile/getToken' }),
		percentuale() {
			const q = Number(this.item.quantity) || 0;
			return q ? Math.min(100, ((Number(this.item.progress) || 0) / q) * 100) : 0;
		},
		// accesa ma fuori periodo: il sito la scarta, lo diciamo perche' l'interruttore acceso farebbe pensare il contrario
		esempioBundle() {
			return prezziBundle(this.item, [100, 60, 40]);
		},
		avvisoDate() {
			return this.item.active && ['date', 'time', 'bundle'].includes(this.item.operation) && ['scaduta', 'non ancora iniziata'].includes(statoDate(this.item).testo);
		},
		referenze() {
			const o = this.item;
			return [
				...(o.items || []).map(x => ({ icona: 'mdi-shopping-outline', testo: formatItemText(x) })),
				...(o.brands || []).map(x => ({ icona: 'mdi-tag-outline', testo: `Brand ${x?.name || ''}` })),
				...(o.categories || []).map(x => ({ icona: 'mdi-sitemap-outline', testo: `Categoria ${x?.name || x?.string || ''}` })),
				...(o.customers || []).map(x => ({ icona: 'mdi-account-outline', testo: `${nomeCliente(x)}${x?.buyer?.email ? ' · ' + x.buyer.email : ''}` })),
			];
		},
	},
	methods: {
		sconto,
		euro,
		prezzoScontato,
		statoDate,
		frase,
		caricaStatistiche() {
			axios
				.get(`${this.getUrl}offers/${this.item._id}/bundle-stats`, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.statistiche = data && data.data ? data.data : null;
				})
				.catch(err => console.log(err));
		},
	},
};
</script>

<style scoped>
.od-detail {
	width: 100%;
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	white-space: normal;
}
.od-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.od-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.od-body {
	display: grid;
	grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
	gap: 16px;
	padding: 12px;
}
.od-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.od-muted {
	color: #5f6b7a;
}
.od-small {
	font-size: 13px;
}
.od-box {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
}
.od-pad {
	padding: 10px 12px;
}
.od-sentence {
	font-size: 14px;
	line-height: 1.5;
}
.od-warn {
	padding: 6px 8px;
	border-radius: 6px;
	background: #fff6e5;
	color: #7a4a00;
	font-size: 12px;
}
.od-price {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
}
.od-old {
	color: #8a96a3;
}
.od-new {
	font-size: 18px;
	color: #01579b;
}
.od-ref {
	padding: 2px 0;
	word-break: break-word;
}
@media (max-width: 1023px) {
	.od-body {
		grid-template-columns: 1fr;
	}
}
@media (max-width: 768px) {
	.od-body {
		padding: 8px;
	}
}
</style>
